import { perthAmboyConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PerthAmboyPage() {
  return <CityPageTemplate config={perthAmboyConfig} />;
}